/** Токен устройства (терминала водителя) для заголовочной авторизации.
 *
 *  Обычные терминалы (`/t/i/<code>`) авторизуются HttpOnly-cookie `rf-device-token`.
 *  Мини-приложение MAX открывается в webview со стороннего origin, где cookie
 *  `SameSite=Strict` может не доезжать, поэтому там бэк отдаёт plain-токен в теле
 *  ответа, мы кладём его сюда, а `apiRequest` шлёт `Authorization: Device <token>`.
 *
 *  Ключ намеренно совпадает по смыслу с cookie, но это отдельное хранилище —
 *  cookie фронт прочитать не может (HttpOnly).
 */
const DEVICE_TOKEN_KEY = 'rf-device-token'

export function getDeviceToken(): string | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(DEVICE_TOKEN_KEY) : null
  } catch {
    return null
  }
}

export function setDeviceToken(token: string): void {
  try {
    localStorage.setItem(DEVICE_TOKEN_KEY, token)
  } catch {
    /* приватный режим / нет доступа — игнорируем */
  }
}

export function clearDeviceToken(): void {
  try {
    localStorage.removeItem(DEVICE_TOKEN_KEY)
  } catch {
    /* no-op */
  }
}
